import { Route, Routes } from "react-router-dom"
import ParentQuestionPage from "./pages/ParentQuestionPage"
import List from "./pages/List"

export const Router = () => {
  return (
    <Routes>
      <Route path="/" element={<List />} />
      <Route path="/create" element={<ParentQuestionPage />} />
      <Route path="/:id" element={<ParentQuestionPage />} />
    </Routes>
  )
}
